var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('gmap-map',{staticClass:"shops-google-map",staticStyle:{"width":"100%","height":"300px"},attrs:{"center":_vm.locationData.position,"zoom":15,"map-type-id":"terrain"}},[_c('gmap-marker',{attrs:{"position":_vm.locationData.position,"clickable":true,"draggable":true},on:{"click":function($event){_vm.center=_vm.locationData.position}}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bc88f05c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Shops/GoogleMap.vue
// module id = rz8F
// module chunks = 1